export const TEST_MUTING_LOADING = 'TEST_MUTING_LOADING';
export const TEST_MUTING_FETCH_SUCCESS = 'TEST_MUTING_FETCH_SUCCESS';
export const TEST_MUTING_FETCH_FAIL = 'TEST_MUTING_FETCH_FAIL';
export const TEST_MUTING_RESET = 'TEST_MUTING_RESET';
export const TEST_UNMUTING_MARK_SUCCESS = 'TEST_UNMUTING_MARK_SUCCESS';
export const TEST_MUTING_MARK_SUCCESS = 'TEST_MUTING_MARK_SUCCESS';
export const TEST_UNMUTING_UPDATE_STATUS = 'TEST_UNMUTING_UPDATE_STATUS';
export const TEST_MUTING_UPDATE_STATUS = 'TEST_MUTING_UPDATE_STATUS';
